import { formatTime } from '../../../../commom/formatTime';
import { Typography } from '../../../molecules/Typography';

interface ILessonContent {
  teacher: string | null | undefined;
  time: string | number;
}

export function LessonContent({ teacher, time }: ILessonContent) {
  return (
    <div className='flex w-fit flex-row gap-lg'>
      <Typography
        size='small'
        className='transition delay-100 ease-in-out group-hover:text-card-color-default'
      >
        {typeof time === 'string' ? time : formatTime(time)}
      </Typography>
      <Typography
        size='small'
        className='transition delay-100 ease-in-out group-hover:text-card-color-default'
      >
        {teacher ? `Prof. ${teacher}` : ''}
      </Typography>
    </div>
  );
}
